import React from 'react'
import { t } from '../../../i18n'
import StatusBadge from '../StatusBadge'
import { VersionOrigin, VersionStatus } from './types'

export const STATUS_BADGE_VARIANTS: Record<VersionStatus, string> = {
  draft: 'neutral-outline',
  published: 'success-outline',
  archived: 'neutral-filled'
}

export const ORIGIN_BADGE_VARIANTS: Record<VersionOrigin, string> = {
  manual: 'neutral-outline',
  ai: 'info-outline'
}

interface VersionStatusBadgeProps {
  status: VersionStatus
  versionNumber?: number
}

export const VersionStatusBadge = ({
  status,
  versionNumber
}: VersionStatusBadgeProps) => {
  const statusLabel = t(`versioning.statuses.${status}`)
  const label =
    versionNumber === undefined
      ? statusLabel
      : `${statusLabel} v${versionNumber}`

  return <StatusBadge label={label} variant={STATUS_BADGE_VARIANTS[status]} />
}

export const VersionOriginBadge = ({ origin }: { origin: VersionOrigin }) => (
  <StatusBadge
    label={t(`versioning.origins.${origin}`)}
    variant={ORIGIN_BADGE_VARIANTS[origin]}
  />
)
